module.exports = __webpack_public_path__ + "static/media/home.982f69ed.svg";